import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

type PrivateRouteProps = {
  requireAdmin?: boolean;
};

const PrivateRoute = ({ requireAdmin = false }: PrivateRouteProps) => {
  const { currentUser, loading, isAdmin } = useAuth();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-green-50">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
          <p className="text-lg text-gray-600">جاري التحقق من الصلاحيات...</p>
        </div>
      </div>
    );
  }

  // If not logged in, redirect to login page
  if (!currentUser) {
    console.log('No user found, redirecting to login...');
    return <Navigate to="/admin/login" replace />;
  }

  // If admin access is required but user is not admin, redirect to home page
  if (requireAdmin && !isAdmin) {
    console.log('User is not admin, redirecting to home...');
    return <Navigate to="/" replace />;
  }

  // If authenticated and authorized, render the protected route
  console.log('User is authenticated and authorized');
  return <Outlet />;
};

export default PrivateRoute;